import { loadingEnd } from '../../../../../../../services/MarppleShop/shared/client/global.js';

export const creatorShopLoadingEndListener = (e) => {
  loadingEnd();
};

export const creatorShopAppListener = function (e) {
  try {
    const { is_focused } = JSON.parse(e.data);
    if (is_focused) {
      loadingEnd();
    }
  } catch (err) {}
};
